import { string, func, bool } from 'prop-types';

import { CloseSVG } from 'components/iconsSVG/close';

import styles from './style.module.css';

export function FilterTag({
  color, onClick, label, checked = false, type, available = true,
}) {
  // si el color es un linear gradient, le quitamos las comillas
  return (
    <button
      type="button"
      className={styles.filterTag}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick?.();
      }}
      data-checked={checked}
      data-type={type}
      data-available={available}
    >
      <span className={styles.textWrapper}>
        {color ? <div style={{ background: color }} className={styles.color} /> : null }
        <span className={!color ? '' : styles.colorTagLabel}>
          {label}
        </span>
      </span>
      {checked ? <span className={styles.closeMarkSpan}><CloseSVG/></span> : null}
    </button>
  );
}

FilterTag.propTypes = {
  color: string,
  onClick: func,
  label: string,
  checked: bool,
  disabled: bool,
  type: string,
  available: bool,
};
